import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { testimonials, fadeUp } from "@/data/site";

const Testimonials = ({ showHeading = true }) => {
  return (
    <AnimatedSection id="depoimentos" className="section-padding bg-white">
      <div className="container-custom">
        {showHeading && (
          <motion.div variants={fadeUp} className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
              O que nossos clientes dizem
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-4">
              Depoimentos
            </h2>
            <div className="section-divider mx-auto mb-6" />
            <p className="text-[#5C5C5C] max-w-2xl mx-auto">
              A satisfação dos nossos clientes é o nosso maior orgulho. Veja o que eles têm a dizer sobre nossos serviços.
            </p>
          </motion.div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              variants={fadeUp}
              custom={index}
              data-testid={`testimonial-card-${index}`}
              className="testimonial-card bg-[#F5F5F5] p-8 relative"
            >
              <div className="absolute top-6 right-6">
                <Quotes size={40} weight="fill" className="text-[#E73336]/20" />
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} weight="fill" className="text-[#FFB800]" />
                ))}
              </div>

              <p className="text-[#2B2B2B] leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#234D89] rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-semibold text-[#234D89]">{testimonial.name}</h4>
                  <p className="text-sm text-[#5C5C5C]">{testimonial.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Testimonials;
